import {call, put} from "redux-saga/effects";
import {
  getFactureSouscriptionApi,
  paiementSouscriptionApi,
  tracePaymentInAccountApi,
} from "../../../../common/apis/souscriptionApi";
import * as actions from "../state/paiementSouscriptionActions";

export function* getFactureSouscriptionSaga({ payload }) {
  try {
    const response = yield call(getFactureSouscriptionApi, payload);
    yield put(actions.getFactureSouscriptionSuccessAction(response.data.body));
  } catch (error) {
    yield put(actions.getFactureSouscriptionFailAction(error));
  }
}

export function* paiementSouscriptionSaga({ payload }) {
  try {
    const response = yield call(paiementSouscriptionApi, payload);
    yield put(actions.paiementSouscriptionSuccessAction(response.data.body));
  } catch (error) {
    yield put(actions.paiementSouscriptionFailAction(error));
  }
}

export function* tracePaymentInAccountSaga({ payload, onSuccess }) {
  try {
    const response = yield call(tracePaymentInAccountApi, payload);
    yield put(actions.tracePaymentInAccountSuccess(response.data.body));
    onSuccess();
  } catch (error) {
    yield put(actions.tracePaymentInAccountFail(error));
  }
}
